import { createTemporaryId } from "../utils/model";
import Contact from "./Contact";

export class ContactUpdateRecord {
  readonly id: string = createTemporaryId();
  readonly contactId: string;
  readonly userId: string;
  readonly beforeUpdate: Partial<Contact>;
  /**
   * UI only.
   */
  readonly afterUpdate?: Partial<Contact>;
  readonly date: Date = new Date()

  constructor(deriveFrom?: Partial<ContactUpdateRecord>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.date = new Date(this.date);
  }
}